import { IconWebhook } from '@developerz/ui';
import type { JSX } from 'solid-js';
import { For } from 'solid-js';
import { t } from '../i18n';
import type { RepoWebhookBinding } from '../lib/repo-detail';
import { StatusPill } from './StatusPill';
import { Button } from './ui/Button';

// One webhook binding row in the repo Settings tab (#195), in row-list
// language (spec §3.15): icon tile + name/url/trigger lines, health pill.
// Presenter — "Test" fires the caller's handler (`POST /v1/webhooks/:id/test`
// through the container). Omitting `onTest` renders it disabled rather than
// hidden, same contract as `WebhookCard`: a caller who can't write still sees
// what the control would do.
export function WebhookRow(props: {
  hook: RepoWebhookBinding;
  onTest?: (id: string) => void;
  /** This row's test-send is in flight — the button reads "Testing…". */
  testing?: boolean;
}): JSX.Element {
  return (
    <li class="row-list__row webhook-entry">
      <div class="row-list__lead webhook-entry__lead">
        <span class="row-list__tile">
          <IconWebhook />
        </span>
        <div class="webhook-entry__lines">
          <p class="webhook-entry__name">
            {props.hook.name}
            <StatusPill tone={props.hook.healthy ? 'success' : 'danger'}>
              {t(props.hook.healthy ? 'repo_detail.settings_active' : 'repo_detail.settings_down')}
            </StatusPill>
          </p>
          <p class="webhook-entry__url">
            <code>{props.hook.url}</code>
          </p>
          <p class="webhook-entry__tags">
            <span class="webhook-entry__tags-label">{t('repo_detail.settings_triggers')}</span>
            <For each={props.hook.events}>
              {(ev) => <span class="badge badge--outline">{ev}</span>}
            </For>
          </p>
        </div>
      </div>
      <Button
        variant="ghost"
        size="sm"
        disabled={!props.onTest || props.testing}
        onClick={() => props.onTest?.(props.hook.id)}
      >
        {t(props.testing ? 'repo_detail.settings_testing' : 'repo_detail.settings_test')}
      </Button>
    </li>
  );
}
